import PaymentGatewayProcessor from './paymentGatewayProcessorAbstract';
import {addCurrencySymbol, getTranslation, handlePromise, toggleLoader} from "../index";

export default class GatePayGateway extends PaymentGatewayProcessor {
  processCheckout() {
    return new Promise(async (resolve, reject) => {
      const [checkoutApiCallRes, checkoutApiCallErr] = await handlePromise(this.checkoutInit());
      toggleLoader(false);

      if (checkoutApiCallRes.status) {
        const {merchantId, tradeNo, prepayId, totalFee, currency} = JSON.parse(checkoutApiCallRes.body);

        if (/android/i.test(navigator.userAgent)) {
          window.gateio.gatepay(merchantId, tradeNo, prepayId, totalFee, currency);
        } else if (typeof window.webkit?.messageHandlers?.gatepay === 'object' && ['iPad', 'iPhone'].includes(navigator?.userAgentData?.platform || navigator?.platform)) {
          let params = {
            "merchantId": merchantId,
            "merchantTradeNo": tradeNo,
            "prepayId": prepayId,
            "totalFee": totalFee,
            "currency": currency
          };
          //window.prompt("gatepay", JSON.stringify(params)); //this method does not work
          window.webkit.messageHandlers.gatepay.postMessage(params);
        }

      } else if (checkoutApiCallErr) {
        reject(checkoutApiCallErr)
      }
    });
  }
}
